import CityPageTemplate from "@/pages/hawaii-city/CityPageTemplate";
import { ewaBeachConfig } from "./data";

export default function EwaBeachPage() {
  return <CityPageTemplate config={ewaBeachConfig} />;
}